import React from 'react';
import { Button, Checkbox } from 'antd';
import { navigate } from '@reach/router';

export const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
    showOnEdit: true,
    type: 'number',
    editable: false,
    creatable: false,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    showOnEdit: true,
    type: 'string',
    editable: true,
    creatable: true,
  },
  {
    title: 'Form Type Id',
    dataIndex: 'formTypeId',
    key: 'formTypeId',
    showOnEdit: true,
    type: 'number',
    editable: true,
    creatable: true,
    isForeignKey: true,
  },
  {
    title: 'Customer Company Id',
    dataIndex: 'customerCompanyId',
    key: 'customerCompanyId',
    showOnEdit: true,
    type: 'number',
    editable: true,
    creatable: true,
  },
  {
    title: 'Worksite Company Id',
    dataIndex: 'worksiteCompanyId',
    key: 'worksiteCompanyId',
    showOnEdit: true,
    type: 'number',
    editable: true,
    creatable: true,
  },
  {
    title: 'Service Type Id',
    dataIndex: 'serviceTypeId',
    key: 'serviceTypeId',
    showOnEdit: true,
    type: 'number',
    editable: true,
    creatable: true,
  },
  {
    title: 'Inactive Ind',
    dataIndex: 'inactiveInd',
    key: 'inactiveind',
    render: (value) => <Checkbox checked={value} />,
    showOnEdit: true,
    type: 'boolean',
    editable: true,
    creatable: true,
  },
];

export const getExtraActions = (row) => [
  <Button onClick={() => navigate(`formTemplate/${row.id}/formTemplateElementType`)}>
    ElementTypes
  </Button>,
];
